import { render } from "./scrollspy-nav.vue?vue&type=template&id=25327351"
import script from "./scrollspy-nav.vue?vue&type=script&lang=js"
export * from "./scrollspy-nav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__